import { useCreateEntryTemplate as useCreateEntryTemplateApi } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCreateCollectionItem } from "src/hooks/rxdb"
import { CollectionKey } from "src/types"

export function useCreateEntryTemplate() {
  return useCreateCollectionItem(
    CollectionKey.EntryTemplate,
    "entry_template",
    useCreateEntryTemplateApi,
    (i) => i,
  )
}
